'use strict'

export default class FrontendLogin {
  constructor () {
    this._form = document.querySelector('.authentication form')

    if (this._form !== null) {
      const action = this._form.dataset.action

      if (action !== 'undefined') {
        switch (action) {
          case 'change-password':
            this.changePasswordAction()
            break
          case 'recovery-password':
            this.recoveryPasswordAction()
            break
          case 'sign-in':
            this.signInAction()
            break
        }
      }
    }
  }

  changePasswordAction () {
    this
      ._setAutofocus()
      ._setButtonState()
      ._setWarningsState()
      ._submit()
      ._togglePassword()

    return this
  }

  recoveryPasswordAction () {
    this
      ._setAutofocus()
      ._setButtonState()
      ._submit()

    return this
  }

  signInAction () {
    this
      ._setAutofocus()
      ._setButtonState()
      ._submit()
      ._togglePassword()

    return this
  }

  _addWarning (attribute) {
    const selector = this._form.querySelector(attribute)

    selector.classList.replace('text-success', 'text-danger')
    selector.querySelector('i').classList.replace('fa-check-circle', 'fa-times-circle')

    return this
  }

  _checkConfirmPassword (password1, password2) {
    for (const event of ['blur', 'focus', 'keydown', 'keyup']) {
      password1.addEventListener(event, () => {
        const value = password1.value

        if (value.length >= 8 && value === password2.value) {
          this._removeWarning('[data-identical-passwords="1"]')
        } else {
          this._addWarning('[data-identical-passwords="1"]')
        }
      })
    }

    return this
  }

  _checkMaxChars (password) {
    for (const event of ['blur', 'focus', 'keydown', 'keyup']) {
      password.addEventListener(event, () => {
        if (password.value.length >= 8) {
          this._removeWarning('[data-max-chars="8"]')
        } else {
          this._addWarning('[data-max-chars="8"]')
        }
      })
    }

    return this
  }

  _hidePassword (selector) {
    selector.classList.replace('fa-eye-slash', 'fa-eye')
    selector.closest('.input-group-text').previousElementSibling.type = 'password'

    return this
  }

  _removeWarning (attribute) {
    const selector = this._form.querySelector(attribute)

    selector.classList.replace('text-danger', 'text-success')
    selector.querySelector('i').classList.replace('fa-times-circle', 'fa-check-circle')

    return this
  }

  _setAutofocus () {
    this._form.querySelector('input[autofocus="true"]').focus()

    return this
  }

  _setButtonInProgress (button) {
    button.disabled = true
    button.innerHTML = button.dataset.loadingText

    return this
  }

  _setButtonState () {
    const button = this._form.querySelector('button')
    const passwordFields = this._form.querySelectorAll('input[type="password"]')

    button.disabled = true

    for (const event of ['blur', 'focus', 'keydown', 'keyup']) {
      this._form.addEventListener(event, event => {
        if (event.key !== 'Enter') {
          const inputs = this._form.querySelectorAll('input[type="email"], input[type="password"]')

          let isDisabled = false

          for (const input of inputs) {
            switch (input.type) {
              case 'email':
                if (/^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(input.value) === false) {
                  isDisabled = true
                }
                break
              case 'password':
                if (input.value.length < 8) {
                  isDisabled = true
                }
                break
            }

            if (passwordFields.length === 2) {
              if (passwordFields[0].value !== passwordFields[1].value) {
                isDisabled = true
              }
            }
          }

          button.disabled = isDisabled
        }
      })
    }

    return this
  }

  _setWarningsState () {
    const password = document.querySelector('#pass1')
    const confirmPassword = document.querySelector('#pass2')

    this
      ._checkConfirmPassword(password, confirmPassword)
      ._checkConfirmPassword(confirmPassword, password)
      ._checkMaxChars(password)

    return this
  }

  _showPassword (selector) {
    selector.classList.replace('fa-eye', 'fa-eye-slash')
    selector.closest('.input-group-text').previousElementSibling.type = 'text'

    return this
  }

  _submit () {
    this._form.addEventListener('submit', event => {
      this._setButtonInProgress(event.submitter)
    })

    return this
  }

  _togglePassword () {
    const inputs = document.querySelectorAll('[data-toggle-password="1"]')

    for (const input of inputs) {
      const inputGroup = document.createElement('div')
      inputGroup.classList.add('input-group')
      input.parentNode.insertBefore(inputGroup, input)
      inputGroup.appendChild(input)

      const inputIcon = document.createElement('i')
      inputIcon.setAttribute('aria-hidden', 'true')
      inputIcon.classList.add('fas', 'fa-eye')
      inputIcon.dataset.toggleIcon = '1'
      inputIcon.setAttribute('role', 'button')

      const inputContent = document.createElement('div')

      const inputText = document.createElement('div')
      inputText.classList.add('input-group-text')

      inputContent.appendChild(inputIcon)
      inputText.appendChild(inputContent)
      inputGroup.appendChild(inputText)

      for (const event of ['mouseout', 'mouseup', 'touchend']) {
        inputIcon.addEventListener(event, event => {
          this._hidePassword(event.target)
        })
      }

      for (const event of ['mousedown', 'touchstart']) {
        inputIcon.addEventListener(event, event => {
          this._showPassword(event.target)
        })
      }
    }

    return this
  }
}
